<template>
  <div class="banner-project-setting" v-if="banner && banner.length > 0">
    <toolTip maxWidth="200px" :title="restFirst ? restFirst : banner[0].label" class="first-banner" @click.native="bannerBack">
      <span>{{restFirst ? restFirst : banner[0].label}}</span>
    </toolTip>
    <div class="menu-control-icon" v-if="banner[1]"></div>
    <toolTip v-if="banner[1]" maxWidth="200px" :title="resSene ? resSene : banner[1].label">
      <span >{{resSene ? resSene : banner[1].label}}</span>
    </toolTip>
  </div>
</template>
<script>
import { Storage } from "@/utils/utils";
export default {
  props: ['restFirst', 'resSene'],
  data() {
    return {
      banner: []
    }
  },
  mounted() {
    this.hetHead()
  },
  methods: {
    hetHead() {
      let arr = Storage.getSession('tagList')
      this.banner = arr.slice(-2)
      console.log(arr, this.banner)
    },
     bannerBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.banner-project-setting {
  height: 54px;
  line-height: 54px;
  padding-left: 24px;
  padding-right: 15px;
  background: #fff;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 2;
  font-weight: bold;
  font-size: 16px;
  .first-banner {
    color: rgba(32,32,32,.6);
    cursor: pointer;
    &:hover {
      color: initial;
    }
  }
  .menu-control-icon {
    margin: 0 10px;
    font-size: 16px;
    transform: rotate(30deg);
    &::before {
      content: "";
      display: inline-block;
      width: 1px;
      height: 14px;
      line-height: 18px;
      @include bgColorOpacity(.6);
    }
  }
}
</style>
